import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CODE, COMP_TYPE, DATEPICKER, LOGON_INFO } from '../app.constants';
import { Code, CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { StateRegistService, Statement, StatementRegist } from './state-regist.service';


import $ from 'jquery';
import { INgxMyDpOptions } from 'ngx-mydatepicker';

@Component({
    selector: 'state-regist',
    templateUrl: 'state-regist.component.html',
    providers: [StateRegistService, CompanyService]
})
export class StateRegistComponent implements OnInit {

    state_regist: StatementRegist = new StatementRegist();
    oldRegist: StatementRegist;
    oldHistory: StatementRegist[];
    oldCount: number;
    oldInfo: string;
    newFileName: string;
    today: Date;
    branchList: Company[];
    stateList: Statement[];
    srcStateList: Statement[];
    currentState: Statement;
    totalCount: number;
    statePath: string;

    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    checkbox_toggle_all: boolean = false;

    // (2026.06) 現在選択されている検索タブ
    currentSearchTab: string = 'billing';


    stateMenuList: Code[];
    scaledStateMenuList: Code[];
    // selectedCheckbox: boolean = false;
    menuCheckList: any[];
    savedMenuSelectionState: boolean[] = [];
    isFirstMenuOpen: boolean = true;
    searchBranch: string;

    billCompList: string[];
    custCompList: string[];
    siteNameList: string[];
    prodNameList: string[];

    scaledBillComp: string[];
    scaledCustComp: string[];
    scaledSiteName: string[];
    scaledProdName: string[];

    selectedCheckList: any[];
    selectedCategory: string;
    selectedBillComp: any[];
    selectedCustComp: any[];
    selectedSiteName: any[];
    selectedProdName: any[];

    lengthBillComp: number = 0;
    lengthCustComp: number = 0;
    lengthSiteName: number = 0;
    lengthProdName: number = 0;

    arrYear: number[] = Array.from({ length: 2099 - 1994 + 1 }, (_, i) => i + 1994);
    arrMonth: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
    searchYear: string;
    searchMonth: string;

    nextLink: string;
    prevLink: string;

    siteSelect: boolean = false;
    taxSelect: boolean = false;

    selectCount: number = 0;
    parsingSavedChecklist: Statement[];
    billList: string = '';
    custList: string = '';
    siteList: string = '';
    prodList: string = '';

    constructor(
        public router: Router,
        public commonService: CommonService,
        public companyService: CompanyService,
        public messageService: MessageService,
        public registService: StateRegistService
    ) {}

    ngOnInit() {
        // テスト期間中はアカウント制限あり
        // if (LOGON_INFO.USER_ID != 'daiko-admin' && LOGON_INFO.USER_ID != 'daiko.test') {
        //     this.router.navigate(['/notice-show']);
        //     this.messageService.addError("権限が必要です。");
        //     return;
        // }

        this.today = new Date();
        this.searchYear = this.today.getFullYear().toString();
        this.searchMonth = (this.today.getMonth() + 1).toString();

        this.currentState = new Statement();
        this.stateMenuList = JSON.parse(JSON.stringify(CODE.STATE_MENU));
        this.scaledStateMenuList = this.stateMenuList;
        console.log('scaledStateMenuList?!: ', this.scaledStateMenuList);
        this.searchBranch = LOGON_INFO.COMP_ID;

        this.getBranchList();

        this.refreshPage();
    }


    /**
     * 明細リスト取得
     */
    getStateList() {
        this.commonService.showLoading();

        // this.nextLink = null;
        // this.prevLink = null;

        this.registService.getAllBranchStateList(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.srcStateList = this.stateList = data.results;
                    // this.srcStateList = this.stateList = data;

                    // this.totalCount = this.stateList.length;
                    this.totalCount = data.count;

                    // 本番
                    // data.next ? this.nextLink = data.next.replace('http://', 'https://') : this.nextLink = null;
                    // data.previous ? this.prevLink = data.previous.replace('http://', 'https://') : this.prevLink = null;

                    // 検証、テスト
                    data.next ? this.nextLink = data.next : this.nextLink = null;
                    data.previous ? this.prevLink = data.previous : this.prevLink = null;

                    this.commonService.hideLoading();
                    console.log('stateList?!: ', this.stateList);
                }
            )
    }

    getStatePath() {
        this.registService.getStatePath(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    if (data.length > 0) {
                        this.oldHistory = data;
                        this.oldCount = this.oldHistory.length;

                        this.oldRegist = data[0];
                        this.statePath = this.oldRegist.s3_path;

                        const oldUploader = this.oldRegist.create_id;
                        const oldDate = this.oldRegist.create_date.toString().slice(0,10) + " " + this.oldRegist.create_date.toString().slice(11,19);
                        this.oldInfo = oldUploader + "(" + oldDate + ")";
                    } else {
                        this.oldHistory = [];
                        this.oldCount = 0;
                        this.oldInfo = "なし";
                    }
                }
            )
    }

    getStateFreeTitle() {
        this.registService.getStateFreeTitle(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    // stateMenuListからfree_item_1, free_item_2を見つけてnameを上書き
                    if (this.stateMenuList) {
                        this.stateMenuList.forEach(menu => {
                            if (menu.extra_svalue_1 === 'free_item_1' && data.free_item_1) {
                                menu.name = data.free_item_1;
                            }
                            if (menu.extra_svalue_1 === 'free_item_2' && data.free_item_2) {
                                menu.name = data.free_item_2;
                            }
                        });
                    }
                    if (this.scaledStateMenuList) {
                        this.scaledStateMenuList.forEach(menu => {
                            if (menu.extra_svalue_1 === 'free_item_1' && data.free_item_1) {
                                menu.name = data.free_item_1;
                            }
                            if (menu.extra_svalue_1 === 'free_item_2' && data.free_item_2) {
                                menu.name = data.free_item_2;
                            }
                        });
                    }
                }
            );
    }

    getMenuLabel(fieldName: string): string {
        if (this.stateMenuList) {
            const menu = this.stateMenuList.find(m => m.extra_svalue_1 === fieldName);
            if (menu) {
                return menu.name;
            }
        }
        // 該当するメニューがない場合はデフォルト値を返却
        return fieldName === 'free_item_1' ? 'フリー枠①' : 'フリー枠②';
    }

    /**
     * 指定されたフィールドの値が負の数であるか判定する
     * @param fieldName フィールド名
     * @param val 判定する値
     */
    isNegativeField(fieldName: string, val: any): boolean {
        const targets = ['unit_cost_1', 'free_item_1', 'amount_money_1', 'unit_cost_2', 'free_item_2', 'amount_money_2', 'margin', 'charge'];
        if (!targets.includes(fieldName)) return false;
        if (val === null || val === undefined || val === '') return false;
        let strVal = val.toString().replace(/,/g, '');
        const num = Number(strVal);
        return !isNaN(num) && num < 0;
    }

    /**
     * (2026.06) 請求先検索リスト取得（選択状態保持）
     */
    getSearchBilling() {
        this.registService.getSearchBilling(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.selectedBillComp = [];

                    this.billCompList = data.map((b: any) => b.billing_comp);
                    const billSet = new Set(this.billList ? this.billList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
                    this.billCompList.forEach(e => {
                        const nameVal = e ? e.toString() : "　";
                        this.selectedBillComp.push({name: nameVal, is_selected: billSet.has(nameVal)});
                    })
                    this.lengthBillComp = this.selectedBillComp.length;
                }
            )
    }

    /**
     * (2026.06) 得意先検索リスト取得（選択状態保持）
     */
    getSearchCustomer() {
        this.registService.getSearchCustomer(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.selectedCustComp = [];

                    this.custCompList = data.map((b: any) => b.customer_comp);
                    const custSet = new Set(this.custList ? this.custList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
                    this.custCompList.forEach(e => {
                        const nameVal = e ? e.toString() : "　";
                        this.selectedCustComp.push({name: nameVal, is_selected: custSet.has(nameVal)});
                    })
                    this.lengthCustComp = this.selectedCustComp.length;
                }
            )
    }

    /**
     * (2026.06) 現場名検索リスト取得（選択状態保持）
     */
    getSearchSite() {
        this.registService.getSearchSite(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.selectedSiteName = [];

                    this.siteNameList = data.map((b: any) => b.site_name);
                    const siteSet = new Set(this.siteList ? this.siteList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
                    this.siteNameList.forEach(e => {
                        const nameVal = e ? e.toString() : "　";
                        this.selectedSiteName.push({name: nameVal, is_selected: siteSet.has(nameVal)});
                    })
                    this.lengthSiteName = this.selectedSiteName.length;
                }
            )
    }

    /**
     * (2026.06) 品名検索リスト取得（選択状態保持）
     */
    getSearchProduct() {
        this.registService.getSearchProduct(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.selectedProdName = [];

                    this.prodNameList = data.map((b: any) => b.product_name);
                    const prodSet = new Set(this.prodList ? this.prodList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
                    this.prodNameList.forEach(e => {
                        const nameVal = e ? e.toString() : "　";
                        this.selectedProdName.push({name: nameVal, is_selected: prodSet.has(nameVal)});
                    })
                    this.lengthProdName = this.selectedProdName.length;
                }
            )
    }


    /**
     * 営業所リストを取得（権限は本社のみ？）
     */
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            this.branchList = this.companyService.getCompanyListForCombo();
        }
    }


    getPrevPage() {
        this.commonService.showLoading();

        this.registService.getPageStateList(this.prevLink)
            .subscribe(
                data => {
                    this.srcStateList = this.stateList = data.results;

                    this.totalCount = data.count;

                    // 本番
                    // data.next ? this.nextLink = data.next.replace('http://', 'https://') : this.nextLink = null;
                    // data.previous ? this.prevLink = data.previous.replace('http://', 'https://') : this.prevLink = null;

                    // 検証、テスト
                    data.next ? this.nextLink = data.next : this.nextLink = null;
                    data.previous ? this.prevLink = data.previous : this.prevLink = null;

                    this.checkbox_toggle_all = false;

                    const savedIds = new Set(this.parsingSavedChecklist.map(item => item.id));
                    this.srcStateList.forEach(item => {
                        if (savedIds.has(item.id))      item.is_print_target = true;
                    });

                    this.commonService.hideLoading();
                }
            )
    }


    getNextPage() {
        this.commonService.showLoading();

        this.registService.getPageStateList(this.nextLink)
            .subscribe(
                data => {
                    this.srcStateList = this.stateList = data.results;

                    this.totalCount = data.count;

                    // 本番
                    // data.next ? this.nextLink = data.next.replace('http://', 'https://') : this.nextLink = null;
                    // data.previous ? this.prevLink = data.previous.replace('http://', 'https://') : this.prevLink = null;

                    // 検証、テスト
                    data.next ? this.nextLink = data.next : this.nextLink = null;
                    data.previous ? this.prevLink = data.previous : this.prevLink = null;

                    this.checkbox_toggle_all = false;

                    const savedIds = new Set(this.parsingSavedChecklist.map(item => item.id));
                    this.srcStateList.forEach(item => {
                        if (savedIds.has(item.id))      item.is_print_target = true;
                    });

                    this.commonService.hideLoading();
                }
            )
    }


    //画面リフレッシュ
    refreshPage(): void {
        this.getStateList();
        // this.getSearchBilling();
        // this.getSearchCustomer();
        // this.getSearchSite();
        // this.getSearchProduct();
        this.getStatePath();
        this.getStateFreeTitle();
        this.siteSelect = this.taxSelect = false;
        this.isFirstMenuOpen = true;

        this.totalCount = 0;

        this.parsingSavedChecklist = [];
        this.selectCount = this.parsingSavedChecklist.length;
        this.billList = '';
        this.custList = '';
        this.siteList = '';
        this.prodList = '';
        this.selectedBillComp = [];
        this.selectedCustComp = [];
        this.selectedSiteName = [];
        this.selectedProdName = [];
    }


    // (2024.07)Excelデータアップロード
    async fileAttach(e: any) {
        const file: File[] = e.target.files;

        if (file.length > 0) {
            const fileName = file[0].name.toLowerCase();
            if (fileName.endsWith('.xlsx')) {
                this.state_regist.statement_excel_file = file[0];
                this.state_regist.statement_excel_name = this.newFileName = Date.now().toString() + "_" + file[0].name;
            } else if (fileName.endsWith('.xls')) {
                this.messageService.addError(".xls 形式のファイルは対応しておりません。\nExcelで「名前を付けて保存」から .xlsx 形式で保存し直してから再度添付してください。");
                this.state_regist.statement_excel_file = null;
                this.state_regist.statement_excel_name = null;
                this.newFileName = null;
                e.target.value = '';
            } else {
                this.messageService.addError("Excelファイル（.xlsx）を添付してください。");
                this.state_regist.statement_excel_file = null;
                this.state_regist.statement_excel_name = null;
                this.newFileName = null;
                e.target.value = '';
            }
        }
    }

    // 明細登録
    registStatement() {
        if (this.state_regist.statement_excel_file.size < 1) {
            this.messageService.addError("Excelファイルを添付してください。");
            return;
        }

        this.commonService.showLoading();

        this.registService.registStatement(this.state_regist, this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
            data => {
                this.messageService.addInfo("Excelファイルが登録されました。");
                this.refreshPage();
                this.toggleCheckboxFalse();
                $('#excelUploadModal').modal('hide');
                this.ngOnDestroy();
                this.commonService.hideLoading();
            },
            error => {
                this.commonService.hideLoading();
                let msg = 'エラーが発生しました。管理者にお問い合わせください。';
                if (error && error.error) {
                    if (typeof error.error === 'string') {
                        msg = error.error;
                    } else if (error.error.detail) {
                        msg = error.error.detail;
                    }
                }
                this.messageService.addError(msg);
            }
        )
    }

    // pdfDownload(item_name: string, file_name: string) {
    //     this.commonService.fileDownload(this.currentCar[item_name + "_path"].file_path, this.currentCar.car_no+'_'+file_name+'.PDF');

    excelDownload() {
        this.commonService.fileDownload(this.oldRegist.s3_path, '明細エクセル.xlsx');
    }

    excelUploadModalShow() {
        this.commonService.showLoading();

        this.state_regist = new StatementRegist();
            if (this.totalCount == 0) {
                $('#excelUploadModal .modal-title').text('【明細Excel登録】');
                $('#excelUploadModal .xls-regist').text('Excel登録');
            } else {
                $('#excelUploadModal .modal-title').text('【明細Excel更新】');
                $('#excelUploadModal .xls-regist').text('Excel更新');
            }
            $('#excelUploadModal').modal('show');

        this.commonService.hideLoading();
    }

    statementModalShow(state: Statement) {
        this.commonService.showLoading();

        this.currentState = state;

        this.state_regist = new StatementRegist();
        $('#statementModal').modal('show');

        this.commonService.hideLoading();
    }

    menuMultiSelectModalShow() {
        this.menuCheckList = [];
        // this.selectedCheckbox = false;
        this.menuCheckList = JSON.parse(JSON.stringify(this.scaledStateMenuList));    // Deep copy

        if (this.isFirstMenuOpen || !this.menuCheckList.some((l: any) => l.is_selected === false)) {
            this.menuCheckList.forEach((l: any) => l.is_selected = false);
        }

        this.savedMenuSelectionState = this.menuCheckList.map((m: any) => m.is_selected);

        $('#menuMultiSelectModal').modal('show');
        $('#menuMultiSelectModal .modal-dialog');
    }

    clearMenuCheckList() {
        this.menuCheckList.forEach((c: any) => {
            c.is_selected = false;
        });
    }

    selectAllMenuCheckList() {
        this.menuCheckList.forEach((c: any) => {
            c.is_selected = true;
        });
    }

    isAllSelected(checkList: any[]): boolean {
        if (!checkList || checkList.length === 0) return false;
        return checkList.every((item: any) => item.is_selected);
    }

    toggleMenuSelection(menu: any) {
        if (this.isAllSelected(this.menuCheckList)) {
            this.menuCheckList.forEach((c: any) => {
                c.is_selected = (c === menu);
            });
        } else {
            menu.is_selected = !menu.is_selected;
        }
    }

    restoreMenuSelectionState() {
        if (this.savedMenuSelectionState && this.savedMenuSelectionState.length === this.menuCheckList.length) {
            this.menuCheckList.forEach((c: any, index: number) => {
                c.is_selected = this.savedMenuSelectionState[index];
            });
        }
    }

    uploadHistoryModalShow() {
        $('#uploadHistoryModal').modal('show');
        $('#uploadHistoryModal .modal-dialog');
    }

    // 未使用（削除予定）
    stateMultiSelectModalShow(title: string) {
        this.selectedCheckList = [];
        let tempList = [];
        this.selectedCategory = title;

        if (title == "請求先")      tempList = this.scaledBillComp;
        if (title == "得意先")      tempList = this.scaledCustComp;
        if (title == "現場名")      tempList = this.scaledSiteName;
        if (title == "品名")        tempList = this.scaledProdName;

        tempList.forEach(e => {
            this.selectedCheckList.push({name: e ? e.toString() : "", is_selected: false})
        })


        $('#stateMultiSelectModal').modal('show');
        $('#stateMultiSelectModal .modal-title').text('【 ' + title + '選択 】');
        $('#stateMultiSelectModal .modal-dialog');
    }

    /**
     * (2026.06) 絞り込み条件モーダルの初期表示処理
     */
    stateSearchModalShow() {
        this.selectedBillComp = [];
        this.selectedCustComp = [];
        this.selectedSiteName = [];
        this.selectedProdName = [];

        this.getSearchBilling();
        this.getSearchCustomer();
        this.getSearchSite();
        this.getSearchProduct();

        this.currentSearchTab = 'billing'; // (2026.06) 検索タブを初期値にリセット
        $('[href="#nav-billing"]').tab('show');  //請求先tabを初期選択状態とする
        $('#stateSearchModal').modal('show');
        $('#stateSearchModal .modal-dialog');
    }

    /**
     * (2026.06) 検索タブの選択項目をすべてクリアする
     */
    clearSearchTabSelection() {
        if (this.currentSearchTab === 'billing') {
            this.selectedBillComp.forEach(item => item.is_selected = false);
        } else if (this.currentSearchTab === 'customer') {
            this.selectedCustComp.forEach(item => item.is_selected = false);
        } else if (this.currentSearchTab === 'site') {
            this.selectedSiteName.forEach(item => item.is_selected = false);
        } else if (this.currentSearchTab === 'product') {
            this.selectedProdName.forEach(item => item.is_selected = false);
        }
    }

    /**
     * (2026.06) 検索タブの選択項目をすべて選択状態にする
     */
    selectAllSearchTabSelection() {
        if (this.currentSearchTab === 'billing') {
            this.selectedBillComp.forEach(item => item.is_selected = true);
        } else if (this.currentSearchTab === 'customer') {
            this.selectedCustComp.forEach(item => item.is_selected = true);
        } else if (this.currentSearchTab === 'site') {
            this.selectedSiteName.forEach(item => item.is_selected = true);
        } else if (this.currentSearchTab === 'product') {
            this.selectedProdName.forEach(item => item.is_selected = true);
        }
    }

    getMultiSearchMenuList() {
        // 検索件数が０の場合対策必要！
        const chkList = this.menuCheckList.filter((cd:Code) => cd.is_selected == true);
        if(chkList.length == 0) {
            this.menuCheckList.forEach((c: any) => c.is_selected = true);
        }

        // this.isShowCheckbox = this.selectedCheckbox;
        this.scaledStateMenuList = this.menuCheckList;
        this.isFirstMenuOpen = false;
        this.toggleCheckboxFalse();

        $('#menuMultiSelectModal').modal('hide');
    }

    // 未使用（削除予定）
    getMultiSearchStateList() {
        const srcStateList = this.selectedCheckList.filter((cd:Code) => cd.is_selected == true);
        const searchList = [];

        if(srcStateList.length == 0) {
            this.messageService.addError("選択された項目がありません。");
            return;
        }

        if (this.selectedCategory == "請求先") {
            this.scaledBillComp = srcStateList;

            this.scaledBillComp.map((l: any) => this.srcStateList.forEach((s: Statement) => {
                if(l.name == "") {
                    if(s.billing_comp == null)          searchList.push(s);
                }
                else if(s.billing_comp == l.name)       searchList.push(s);
            }));
        } else if (this.selectedCategory == "得意先") {
            this.scaledCustComp = srcStateList;

            this.scaledCustComp.map((l: any) => this.srcStateList.forEach((s: Statement) => {
                if(l.name == "") {
                    if(s.customer_comp == null)         searchList.push(s);
                }
                else if(s.customer_comp == l.name)      searchList.push(s);
            }));
        } else if (this.selectedCategory == "現場名") {
            this.scaledSiteName = srcStateList;

            this.scaledSiteName.map((l: any) => this.srcStateList.forEach((s: Statement) => {
                if(l.name == "") {
                    if(s.site_name == null)             searchList.push(s);
                }
                else if(s.site_name == l.name)          searchList.push(s);
            }));
        } else if (this.selectedCategory == "品名") {
            this.scaledProdName = srcStateList;

            this.scaledProdName.map((l: any) => this.srcStateList.forEach((s: Statement) => {
                if(l.name == "") {
                    if(s.product_name == null)          searchList.push(s);
                }
                else if(s.product_name == l.name)       searchList.push(s);
            }));
        }

        this.srcStateList = searchList;
        this.totalCount = this.srcStateList.length;

        if (this.srcStateList != this.stateList) {
            this.scaledBillComp = [];
            this.scaledCustComp = [];
            this.scaledSiteName = [];
            this.scaledProdName = [];

            this.billCompList.forEach((l: any) => {
                if (this.srcStateList.some((s: Statement) => s.billing_comp == l))      this.scaledBillComp.push(l);
            })
            this.custCompList.forEach((l: any) => {
                if (this.srcStateList.some((s: Statement) => s.customer_comp == l))     this.scaledCustComp.push(l);
            })
            this.siteNameList.forEach((l: any) => {
                if (this.srcStateList.some((s: Statement) => s.site_name == l))         this.scaledSiteName.push(l);
            })
            this.prodNameList.forEach((l: any) => {
                if (this.srcStateList.some((s: Statement) => s.product_name == l))      this.scaledProdName.push(l);
            })
        }

        $('#stateMultiSelectModal').modal('hide');
    }

    getMultiSearchList() {
        this.siteSelect = this.taxSelect = false;
        this.parsingSavedChecklist = [];
        this.selectCount = this.parsingSavedChecklist.length;

        this.billList = this.selectedBillComp.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
        this.custList = this.selectedCustComp.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
        this.siteList = this.selectedSiteName.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
        this.prodList = this.selectedProdName.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');

        // ゼロ対策
        if(this.billList.length == 0 && this.custList.length == 0 && this.siteList.length == 0 && this.prodList.length == 0) {
            this.messageService.addError("選択された項目がありません。");
            return;
        }

        this.commonService.showLoading();

        this.registService.getSrcBranchStateList(this.searchBranch, this.searchYear, this.searchMonth, this.billList, this.custList, this.siteList, this.prodList)
            .subscribe(data => {

            this.srcStateList = this.stateList = data.results;
            // this.srcStateList = this.stateList = data;

            this.totalCount = data.count;

            // 本番
            // data.next ? this.nextLink = data.next.replace('http://', 'https://') : this.nextLink = null;
            // data.previous ? this.prevLink = data.previous.replace('http://', 'https://') : this.prevLink = null;

            // 検証、テスト
            data.next ? this.nextLink = data.next : this.nextLink = null;
            data.previous ? this.prevLink = data.previous : this.prevLink = null;

            this.commonService.hideLoading();
        })
        this.toggleCheckboxFalse();

        $('#stateSearchModal').modal('hide');
    }

    /**
     * (2026.06) 検索モーダルのキャンセル処理
     */
    cancelMultiSearchList() {
        this.restoreSearchTabSelection();
        $('#stateSearchModal').modal('hide');
    }

    /**
     * (2026.06) 検索タブの選択状態を現在のフィルター状態に復元する
     */
    restoreSearchTabSelection() {
        const billSet = new Set(this.billList ? this.billList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
        this.selectedBillComp.forEach(item => {
            item.is_selected = billSet.has(item.name);
        });

        const custSet = new Set(this.custList ? this.custList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
        this.selectedCustComp.forEach(item => {
            item.is_selected = custSet.has(item.name);
        });

        const siteSet = new Set(this.siteList ? this.siteList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
        this.selectedSiteName.forEach(item => {
            item.is_selected = siteSet.has(item.name);
        });

        const prodSet = new Set(this.prodList ? this.prodList.split('//').map(n => n === 'ISNULL' ? '　' : n) : []);
        this.selectedProdName.forEach(item => {
            item.is_selected = prodSet.has(item.name);
        });
    }

    toggleCheckbox(s: Statement) {
        s.is_print_target = !s.is_print_target;

        if (s.is_print_target)        this.parsingSavedChecklist.push(s);
        else {
            const index = this.parsingSavedChecklist.findIndex(item => item.id === s.id);
            if (index > -1) {
                this.parsingSavedChecklist.splice(index, 1);
            }
        }

        this.selectCount = this.parsingSavedChecklist.length;
    }

    toggleCheckboxAll() {
        this.checkbox_toggle_all = !this.checkbox_toggle_all;

        // 画面上のチェックボックス状態を更新
        this.stateList.forEach((s: Statement) => {
            s.is_print_target = this.checkbox_toggle_all;
        });

        if (this.checkbox_toggle_all) {
            // 現在のページの項目を、重複を避けて選択リストに追加
            const currentIds = new Set(this.parsingSavedChecklist.map(item => item.id));
            this.stateList.forEach(itemToAdd => {
                if (!currentIds.has(itemToAdd.id)) {
                    this.parsingSavedChecklist.push(itemToAdd);
                }
            });
        } else {
            // 現在のページの項目を選択リストから削除
            const idsToRemove = new Set(this.stateList.map(item => item.id));
            this.parsingSavedChecklist = this.parsingSavedChecklist.filter(item => !idsToRemove.has(item.id));
        }

        this.selectCount = this.parsingSavedChecklist.length;
    }

    toggleCheckboxFalse() {
        this.checkbox_toggle_all = false;
        this.stateList.forEach((s: Statement) => {
            s.is_print_target = this.checkbox_toggle_all;
        });
    }

    branchStateSearch() {
        this.refreshPage();
        this.toggleCheckboxFalse();
    }

    /**
     * 請求書発行の確認モーダルを表示
     */
    printConfirmModalShow() {
        if (this.parsingSavedChecklist.length === 0) {
            this.messageService.addError("選択された項目がありません。");
            return;
        }
        $('#printConfirmModal').modal('show');
    }

    /**
     * 請求書Excelの発行を実行
     * @param printAll true: 全件, false: 選択した件のみ
     */
    executePrint(printAll: boolean) {
        if (printAll) {
            this.commonService.showLoading();
            this.billList = this.selectedBillComp.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
            this.custList = this.selectedCustComp.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
            this.siteList = this.selectedSiteName.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');
            this.prodList = this.selectedProdName.filter((cd:Code) => cd.is_selected == true).map((c:Code) => c.name).map((n: string) => { return n == '　' ? 'ISNULL' : n}).join('//');

            this.registService.getSrcBranchStateListAll(this.searchBranch, this.searchYear, this.searchMonth, this.billList, this.custList, this.siteList, this.prodList)
                .subscribe(data => {
                    this.stateBillExportAsExcelJs(data);
                    this.commonService.hideLoading();
                });
        } else {
            this.stateBillExportAsExcelJs(this.parsingSavedChecklist);
        }
        $('#printConfirmModal').modal('hide');
    }

    stateBillExportAsExcelJs(printList: Statement[]) {
        const printSiteList = [];
        const printTaxList = [];
        let site_total: number = 0;
        let tax_total: number = 0;
        const targetStateList : any[] = [];

        let printArray : any[][] = [];
        if (this.siteSelect) {
            const siteArray = printList.reduce((acc, obj) => {
                const key = obj.site_name;
                if(!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(obj);

                return acc;
            }, {});

            printArray = Object.values(siteArray);
        } else printArray[0] = printList;
        const pLen = printArray.length;

        for (let p=0; p<pLen; p++) {
            let rack = '', siteName = '';
            let quantity = 0;
            site_total = tax_total = 0;

            printArray[p].forEach((sl: Statement) => {
                if (sl.product_name && sl.product_name.includes('高速代')) {
                    const tax_state: any[] = [];

                    if (!tax_total) {
                        rack = sl.rack_1;
                        printArray[p][0].site_name == sl.site_name ? siteName = '〃' : siteName = sl.site_name;
                        quantity = sl.quantity_1;
                    }
                    tax_state.push(sl.transfer_date);
                    tax_state.push(sl.parent_comp_name);
                    tax_state.push(sl.car_no);
                    tax_state.push(sl.car_type);
                    tax_state.push(sl.site_name);
                    tax_state.push(sl.product_name);
                    tax_state.push(sl.day_night);
                    tax_state.push(sl.quantity_1);
                    tax_state.push(sl.rack_1);
                    if (this.taxSelect)                 tax_state.push(Math.trunc(sl.amount_money_1 * 1.1));
                    tax_state.push(sl.amount_money_1);

                    printTaxList.push(tax_state);
                    tax_total += sl.amount_money_1;
                } else {
                    const site_state: any[] = [];

                    site_state.push(sl.transfer_date);
                    site_state.push(sl.parent_comp_name);
                    site_state.push(sl.car_no);
                    site_state.push(sl.car_type);
                    site_state.push(sl.customer_comp);
                    site_state.push(sl.site_name);
                    site_state.push(sl.product_name);
                    site_state.push(sl.day_night);
                    site_state.push(sl.quantity_1);
                    site_state.push(sl.rack_1);
                    site_state.push(sl.unit_cost_1);
                    site_state.push(sl.amount_money_1);

                    printSiteList.push(site_state);
                    site_total += sl.amount_money_1;
                }
            })

            if (site_total) {
                targetStateList.push([targetStateList.length == 0 ? this.searchMonth+"月分" : null, null, "運送一式", printArray[p][0].site_name, printArray[p][0].quantity_1, printArray[p][0].rack_1, site_total, site_total]);
                // targetStateList.push(["", "", "", "別紙明細の通り"]);
            }
            if (tax_total) {
                if (targetStateList.length == 0)    targetStateList.push([this.searchMonth+"月分", null, "高速代", printArray[p][0].site_name, printArray[p][0].quantity_1, printArray[p][0].rack_1, tax_total, tax_total]);
                else                                targetStateList.push([null, null, "高速代", siteName, quantity, rack, tax_total, tax_total, this.taxSelect ? null : '非課税']);
                // targetStateList.push(["", "", "", "別紙明細の通り"]);
            }
        }
        targetStateList.push(["", "", "", "別紙明細の通り"]);

        // 「現場名」表示分けの処理
        // const targetStateList = printStateList.map((sm: Statement) => {
        //     const new_state: any[] = [];

        //     new_state.push(sm.transfer_date);
        //     new_state.push(null);
        //     new_state.push(sm.product_name);
        //     new_state.push(sm.site_name);
        //     new_state.push(sm.quantity_1);
        //     new_state.push(sm.rack_1);
        //     new_state.push(sm.unit_cost_1);
        //     new_state.push(sm.amount_money_1);
        //     // new_state.push(sm.summary_1);

        //     return new_state;
        // });

        const printItemList = ["月　日", "", "品　　名", "区　　間", "数　量", "単位", "単　価", "金　　額", "摘　　要"];
        const taxItemList = [" ", " ", "税率", "税抜き額", "消費税", " ", "税込額", " "];
        const siteIndex = ["月日", "社名（所属）", "車両番号", "車両種", "得意先", "現場名", "品名", "昼夜", "数量", "単位", "単価", "金額"];
        const taxIndex = ["月日", "社名（所属）", "車両番号", "車両種", "現場名", "品名", "昼夜", "数量", "単位", "明細金額"];
        if (this.taxSelect)     taxIndex.push("税抜金額");

        const fileName = this.searchYear+(this.searchMonth.length == 1 ? '0'+this.searchMonth : this.searchMonth) + "_" + this.branchList.find(f => f.comp_id === this.searchBranch).name;

        this.commonService.printBillExportAsExcelJs(printItemList, taxItemList, targetStateList, printSiteList, printTaxList, siteIndex, taxIndex, this.taxSelect, fileName);
    }

    clearSearchItem() {
        // this.srcStateList = this.stateList;
        // this.totalCount = this.srcStateList.length;
        this.scaledStateMenuList = this.stateMenuList;

        // this.scaledBillComp = this.billCompList;
        // this.scaledCustComp = this.custCompList;
        // this.scaledSiteName = this.siteNameList;
        // this.scaledProdName = this.prodNameList;
        // // this.searchBranch = LOGON_INFO.COMP_ID;

        // this.checkbox_toggle_all = false;
        // this.stateList.forEach((s: Statement) => {
        //     s.is_print_target = false;
        // })

        this.siteSelect = this.taxSelect = false;
        this.isFirstMenuOpen = true;

        this.refreshPage();
        this.toggleCheckboxFalse();
    }

    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }
}



// WEBPACK FOOTER //
// ./src/app/statement/state-regist.component.ts